import { faXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, Flex, Text } from '@modusign/design-system';

function LabelSelectPopoverHeader({ onClose }: { onClose: () => void }) {
  return (
    <Flex alignItems="center" justifyContent="space-between" pt={4} px={4} width="100%">
      <Text color="textNeutralLight" fontSize="xs">
        라벨
      </Text>
      <Box as="button" onClick={onClose}>
        <Box as={FontAwesomeIcon} color="textNeutralLight" icon={faXmark} />
      </Box>
    </Flex>
  );
}

export default LabelSelectPopoverHeader;
